import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AltShortcutProvider } from '../contexts/AltShortcutContext';

const TenantRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { tenantCode } = useParams();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // System admins should not access tenant routes
  if (user.is_system_admin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // tenant_subdomain may live on the user object or in localStorage depending on login flow
  const tenantSubdomain = user.tenant_subdomain || localStorage.getItem('tenant_subdomain');

  // Verify tenant code matches user's tenant
  if (tenantSubdomain && tenantCode !== tenantSubdomain) {
    return <Navigate to={`/app/${tenantSubdomain}/dashboard`} replace />;
  }

  // AltShortcutProvider wraps every routed page here (not inside Layout) so
  // that a page's own top-level useAltShortcut calls — which run before the
  // page renders <Layout> as a child — are still inside the provider's
  // subtree. Layout only renders the badge overlay/help modal consumers.
  return <AltShortcutProvider>{children}</AltShortcutProvider>;
};

export default TenantRoute;




